export default __webpack_public_path__ + "static/media/0star.065bfa66.png";